<template>
  <v-form v-model="valid" ref="mainForm">
    <data-iterator
      :list="sas.sasEquivalenceDiplome"
      add-new-text="Ajouter un diplôme"
      :live="{ endpoint: 'sas-diplomes', sasId: sas.id }"
      :icon="$getIcon('school')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive code="diplome_titre" v-model="item.titreDuDiplome" :live="liveSasDiplomes(6302, item)" />
        <DatePickerLive
          code="diplome_date"
          v-model="item.dateDObtention"
          :live="liveSasDiplomes(6312, item)"
          :maxValue="convertDateToString(new Date())"
        />
        <CatalogueLive code="diplome_universite" v-model="item.etablissementEnFranceARMFrance" :live="liveSasDiplomes(6314, item)" />
        <FileInput code="diplome_preuve" :file="item.copieDuDiplome" :live="liveSasDiplomes(6307, item)" />
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"

export default {
  mixins: [CataloguesHelpers, StepFormWithValidation, DatesHelpers],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasDiplomes(cle, item) {
      return { endpoint: "sas-diplomes", cle: cle, fileId: item.id }
    }
  }
}
</script>

<style></style>
